// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","976":"c16184b3"}[chunkId] + "-" + {"218":"1bea25816f9fc094b06d","691":"df977ffe28b0aecf0975","976":"bc677217192a8ded892e"}[chunkId] + ".js";
};